import { render, staticRenderFns } from "./AddSignatures.vue?vue&type=template&id=e20b87e4&scoped=true"
import script from "./AddSignatures.vue?vue&type=script&lang=js"
export * from "./AddSignatures.vue?vue&type=script&lang=js"
import style0 from "./AddSignatures.vue?vue&type=style&index=0&id=e20b87e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20b87e4",
  null
  
)

export default component.exports